<template>
    <span>
        <IconBase iconName="androidIcon"
                  :iconColor="consts.COLORS[color]"
                  v-if="platform === 'android'"
                  key="android"
                  height="12px"
                  width="12px"></IconBase>
        <IconBase iconName="iosIcon"
                  :iconColor="consts.COLORS[color]"
                  v-if="platform === 'ios'"
                  key="ios"
                  height="12px"
                  width="12px"></IconBase>
    </span>
</template>

<script>
import consts from 'services/metaData/consts';
import IconBase from 'components/IconBase.vue';

export default {
    name: 'Platform',
    components: { IconBase },
    props: {
        platform: String,
        color: {
            type: String,
            default: 'LIGHT_700'
        }
    },
    data() {
        return {
            consts
        };
    }
};
</script>
